import { useState } from "react";
import { Link } from "react-router-dom";
import banner from "../images/wespta-skisale.jpg";
import { useCreateAuthToken } from "../hooks/useAuth";
import { useCreateAccount } from "../hooks/useAccount";
import { validateEmail, toTitleCase } from "../constants/helpers";

const closed = false;

function Registration() {
  const auth = useCreateAuthToken();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [consent1, setConsent1] = useState(false);
  const [consent3, setConsent3] = useState(false);
  const [magicLink, setMagicLink] = useState(false);
  const [existing, setExisting] = useState(false);

  const [errors, setErrors] = useState([]);

  const create = useCreateAccount();

  const validate = () => {
    const e = [];

    if (!firstName) e["firstName"] = "required";
    if (!lastName) e["lastName"] = "required";
    if (!email) e["email"] = "required";
    //if (!validateEmail()) e['email'] = 'invalid email';
    if (!phone) e["phone"] = "required";
    if (!address1) e["address1"] = "required";
    if (!city) e["city"] = "required";
    if (!state) e["state"] = "required";
    if (!zip) e["zip"] = "required";
    if (!consent1) e["consent1"] = "required";
    if (!consent3) e["consent3"] = "required";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onChange = (e, setter) => {
    e.preventDefault();

    setter(e.target.value);
  };

  const save = () => {
    if (!validate()) return false;

    create
      .mutateAsync({
        first_name: toTitleCase(firstName),
        last_name: toTitleCase(lastName),
        email: email.toLowerCase().trim(),
        phone: phone.trim(),
        address1: toTitleCase(address1),
        address2: toTitleCase(address2),
        city: toTitleCase(city),
        state: state.toUpperCase().trim(),
        zip: zip.trim(),
      })
      .then((res) => {
        //auth.mutate({ email: email });
        setMagicLink(true);
        return res;
      })
      .catch((err) => {
        if (err.response.data.message === "An account already exists")
          setExisting(true);
      });
  };

  if (closed) {
    return (
      <div className="columns">
        <div className="column is-one-fifth"></div>
        <div className="column is-three-fifths">
          <div className="notification is-warning has-text-centered mt-6">
            <div className="mb-5">
              <p className="is-size-3 has-text-weight-bold mb-4">
                Consignment for the 2026 Waitsfield PTA Ski &amp; Skate Sale has closed.
              </p>
              <p className="is-size-5">
                Thanks for participating in this year's sale. Stay tuned for updates
                on next year's sale!
              </p>
            </div>
            <div className="mt-5">
              <Link to="/" className="button is-info is-medium">
                <span className="icon">
                  <i className="fas fa-arrow-left"></i>
                </span>
                <span>Back to Login</span>
              </Link>
            </div>
          </div>
        </div>
        <div className="column is-one-fifth"></div>
      </div>
    );
  }

  if (!closed) {
    return (
      <>
        <div className="columns">
          <div className="column is-one-fifth"></div>
          <div className="column is-three-fifth">
            <div className="mb-3">
              <img src={banner} />
            </div>
            <div className="content mx-4">
              <div className="title">WES 2026 Ski & Skate Sale</div>
              <div className="subtitle">
                November 14th 9am-4pm Waitsfield Elementary
              </div>

              {!magicLink && (
                <div className="mt-3">
                  Upon registration you will receive an email to login to your
                  Ski & Skate sale account to enter your consignment items.
                  <ul>
                    <li>All items must be entered by 11PM Nov. 9th 2026.</li>
                    <li>
                      <strong>11/11</strong> Tag Pickup @ Waitsfield Elementary
                      School. Please find the envelope with your last name to
                      pickup your printed tags for consignment items. Tags will
                      be available at drop off Friday night if you cannot pick
                      them up before.
                    </li>
                    <li>
                      Drop off Nov. 13th from 4pm to 7pm at Waitsfield
                      Elementary
                    </li>
                  </ul>
                  <strong>
                    There will be no on-site consignment registration.
                  </strong>
                </div>
              )}
            </div>
          </div>
          <div className="column is-one-fifth"></div>
        </div>

        {magicLink && (
          <div className="columns">
            <div className="column is-one-fifth"></div>
            <div className="column is-three-fifth has-text-centered">
              <hr />
              <p className="subtitle">Thank you for registering.</p>
              <div className="title">
                <Link to="/">
                  Click here to login with the email you provided
                </Link>
              </div>
              <div className="is-size-4 has-text-weight-semibold">
                Important Consignment Dates
              </div>
              <div className="content">
                <ul className="has-text-left">
                  <li>
                    <strong>11/9</strong> at 11pm Consignment Registration
                    Closes. There will be NO ON SITE CONSIGNMENT. ALL ITEMS MUST
                    BE REGISTERED ONLINE BY 11/9.
                  </li>
                  <li>
                    <strong>11/11</strong> Tag Pickup @ Waitsfield Elementary
                    School. Please find the envelope with your last name to
                    pickup your printed tags for consignment items. Tags will be
                    available at drop off Friday night if you cannot pick them
                    up before.
                  </li>
                  <li>
                    <strong>11/13</strong> Consignment Drop Off at Waitsfield
                    Elementary from 4-7pm
                  </li>
                  <li>
                    <strong>11/14</strong> Consignment Pickup 3:45-4:15. Check
                    your Ski and Skate sale dashboard to see what has sold and
                    what has not sold. Any unsold items not picked up by 4:15
                    will become property of the WES PTA.
                  </li>
                </ul>
              </div>
            </div>
            <div className="column is-one-fifth"></div>
          </div>
        )}

        {closed && (
          <div className="columns mx-1 has-text-centered">
            <div className="column is-one-fifth"></div>
            <div
              className="column is-three-fifths"
              style={{ borderTop: "1px solid #CCCCCC" }}
            >
              <strong className="is-size-3">
                Registration is closed for the 2026 sale.
              </strong>
              <p>
                If you are have a question or concern, please reach out to:{" "}
                <a href="mailto: wesskiandskate@gmail.com">
                  wesskiandskate@gmail.com
                </a>
              </p>
            </div>
            <div className="column is-one-fifth"></div>
          </div>
        )}

        {!magicLink && !closed && (
          <div className="columns mx-1">
            <div className="column is-one-fifth"></div>
            <div
              className="column is-three-fifths"
              style={{ borderTop: "1px solid #CCCCCC" }}
            >
              <div className="columns">
                <div className="column">
                  <div className="field">
                    <label className="label">
                      First Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        name="firstName"
                        onChange={(e) => onChange(e, setFirstName)}
                        value={firstName}
                      />
                      {errors.firstName && (
                        <div className="has-text-danger has-text-weight-semibold">
                          {errors.firstName}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="column">
                  <div className="field">
                    <label className="label">
                      Last Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        name="lastName"
                        onChange={(e) => onChange(e, setLastName)}
                        value={lastName}
                      />
                      {errors.lastName && (
                        <div className="has-text-danger has-text-weight-semibold">
                          {errors.lastName}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <div className="field">
                    <label className="label">
                      Email <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        name="email"
                        onChange={(e) => onChange(e, setEmail)}
                        value={email}
                      />
                      {errors.email && (
                        <div className="has-text-danger has-text-weight-semibold">
                          {errors.email}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="column">
                  <div className="field">
                    <label className="label">
                      Phone <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        name="phone"
                        mask="(999) 999-9999"
                        onChange={(e) => onChange(e, setPhone)}
                        value={phone}
                      />
                      {errors.phone && (
                        <div className="has-text-danger has-text-weight-semibold">
                          {errors.phone}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <div className="field">
                    <label className="label">
                      Mailing Address Line 1{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        name="address1"
                        onChange={(e) => onChange(e, setAddress1)}
                        value={address1}
                      />
                      {errors.address1 && (
                        <div className="has-text-danger has-text-weight-semibold">
                          {errors.address1}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <div className="field">
                    <label className="label">Address Line 2</label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        name="address2"
                        onChange={(e) => onChange(e, setAddress2)}
                        value={address2}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <div className="field">
                    <label className="label">
                      City <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        name="city"
                        onChange={(e) => onChange(e, setCity)}
                        value={city}
                      />
                      {errors.city && (
                        <div className="has-text-danger has-text-weight-semibold">
                          {errors.city}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="column is-narrow">
                  <div className="field">
                    <label className="label">
                      State (Abbreviated, ie. VT){" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        name="state"
                        onChange={(e) => onChange(e, setState)}
                        value={state}
                      />
                      {errors.state && (
                        <div className="has-text-danger has-text-weight-semibold">
                          {errors.state}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="column is-narrow">
                  <div className="field">
                    <label className="label">
                      Zip <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        name="zip"
                        onChange={(e) => onChange(e, setZip)}
                        value={zip}
                      />
                      {errors.zip && (
                        <div className="has-text-danger has-text-weight-semibold">
                          {errors.zip}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="columns"
                style={{ borderTop: "1px solid #CCCCCC" }}
              >
                <div className="column is-narrow">
                  <input
                    type="checkbox"
                    name="consent"
                    value={consent1}
                    onClick={(e) => setConsent1(!consent1)}
                  />
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div className="column">
                  I understand that pick up of unsold items will be by 4:15PM
                  (pick up is 3:45 - 4:15) on Saturday 11/14 at Waitsfield
                  Elementary or they will be become property of the Waitsfield
                  PTA.
                  {errors.consent1 && (
                    <div className="has-text-danger has-text-weight-semibold">
                      {errors.consent1}
                    </div>
                  )}
                </div>
              </div>
              <div
                className="columns"
                style={{ borderBottom: "1px solid #CCCCCC" }}
              >
                <div className="column is-narrow">
                  <input
                    type="checkbox"
                    name="consent"
                    value={consent3}
                    onClick={(e) => setConsent3(!consent3)}
                  />
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div className="column">
                  I understand that Waitsfield PTA is not responsible for lost
                  or stolen items.
                  {errors.consent3 && (
                    <div className="has-text-danger has-text-weight-semibold">
                      {errors.consent3}
                    </div>
                  )}
                </div>
              </div>
              {existing && (
                <div className="notification is-warning has-text-centered">
                  An account already exists for this email address.
                  <br />
                  <Link to="/">Please try requesting a login link</Link>.
                </div>
              )}
              <div className="has-text-centered mb-6">
                <button className="button is-info is-large" onClick={save} disabled={create.isLoading}>
                  Submit
                </button>
              </div>
            </div>
            <div className="column is-one-fifth"></div>
          </div>
        )}
      </>
    );
  }
}

export default Registration;
